import { styled } from "@mui/material";

export const ExpenseTypeRow = styled("tr")`
  > td {
    border-right: 1px solid ${(props) => props.theme.palette.table.expendedComponent};
    border-bottom: 1px solid ${(props) => props.theme.palette.table.expendedComponent};
    padding: ${(props) => props.theme.spacing(1.5)};
    font-weight: 500;
    color: ${(props) => props.theme.palette.text.primary};

    &:nth-of-type(1) {
      border-left: 1px solid ${(props) => props.theme.palette.table.expendedComponent};
    }

    &:nth-of-type(2) {
      text-align: center;
    }
    &:nth-of-type(4),
    &:nth-of-type(5),
    &:nth-of-type(6) {
      text-align: center;
    }
  }
`;
